var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.loading)?_c('gl-loading-icon',{staticClass:"gl-mt-4",attrs:{"size":"lg"}}):_c('failed-jobs-table',{attrs:{"failed-jobs":_vm.failedJobs}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }